module.exports = __webpack_public_path__ + "img/5.png.2eebf7af.webp";